import { useState, useEffect } from "react"
import { useQuery } from "react-query"
import { useGetToken } from "../../../Hooks/CustomHooks"
import { GetCierreMes, SaveCierreMes } from "../../../api/Api"
import { Spinner } from "react-bootstrap"
import DatePicker from "react-datepicker"

export default function CierreMes({ setSaved }) {

    const token = useGetToken()
    const [date, setDate] = useState(null)
    const [dateToServer, setDateToServer] = useState(null)
    const [disabled, setDisabled] = useState(true)
    const [status, setStatus] = useState(null)
    const [getCierreMes, setGetCierreMes] = useState(true)
    const [saveCierreMes, setSaveCierreMes] = useState(false)
    const currentDate = new Date()
    const [isQuerying, setIsQuerying] = useState(false);

    let currentMonth = (currentDate.getMonth() < 9) ? `0${currentDate.getMonth() + 1}` : currentDate.getMonth() + 1
    let currentFormatDate = `${currentMonth.toString()}/${currentDate.getFullYear().toString()}`

    let { data: dataGetCierreMes, isLoading, isError } = useQuery('CierreMes',
        async () => {
            setIsQuerying(true);
            const response = await GetCierreMes({ cierreMes: dateToServer ? dateToServer : currentFormatDate, token: token })
            setIsQuerying(false);
            return response;
        },
        {
            enabled: getCierreMes
        }
    )

    useEffect(() => {
        if (!isQuerying && dataGetCierreMes) {
            if (dataGetCierreMes.success) {
                setStatus(dataGetCierreMes.data.cierreMes)
                setDisabled(false);
                setGetCierreMes(false)
            }
        }
    }, [dataGetCierreMes, isQuerying])

    let { data: dataSaveCierreMes, isLoading: isLoadingSave } = useQuery('SaveCierreMes',
        async () => await SaveCierreMes({ cierreMes: dateToServer, status: !status, token: token }),
        {
            enabled: saveCierreMes
        }
    )

    useEffect(() => {
        if (dataSaveCierreMes) {
            if (dataSaveCierreMes.success) {
                setSaved(true)
                setSaveCierreMes(false)
                setDisabled(true)
            }
        }
    }, [dataSaveCierreMes])

    return (
        <div className="align-items-end d-flex justify-content-between">
            <div style={{ width: '80%' }}>
                <div className="fw-bold fs-7 text-gray-600 mb-1">Bloqueo de cierre de mes:</div>
                <DatePicker
                    className="form-control form-control-transparent pe-5"
                    locale="es"
                    selected={date}
                    onChange={(dateX) => {
                        setDate(dateX)
                        let formatDate = new Date(dateX)
                        let month = (formatDate.getMonth() < 9) ? `0${formatDate.getMonth() + 1}` : formatDate.getMonth() + 1
                        formatDate = `${month.toString()}/${formatDate.getFullYear().toString()}`
                        setDateToServer(formatDate)
                        setGetCierreMes(true)
                    }}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                />
            </div>
            <button type="button" className="btn btn-primary btn-md d-flex ms-2" disabled={disabled} onClick={() => {
                setSaveCierreMes(true)
            }}>
                {(status) ? 'Desbloquear' : 'Bloquear'}
                {isLoadingSave &&
                    <Spinner animation="border" variant="secondary" role="status" className="loading d-flex justify-content-center superadmin-spinner"></Spinner>
                }
            </button>
        </div>
    )
}